<template>
	<v-dialog v-model="open" fullscreen persistent no-click-animation transition="dialog-bottom-transition" :scrim="false" class="nav-mobile-menu">
		<v-card class="nav-mobile-menu__card">
			<v-sheet :color="color" class="nav-mobile-menu__header">
				<button type="button" class="nav-mobile-menu__user" :disabled="Boolean(nav.delegation)" @click="run('profile')">
					<v-icon size="36">{{ nav.delegation ? 'group' : 'account_circle' }}</v-icon>
					<span class="nav-mobile-menu__user-infos">
						<span class="nav-mobile-menu__user-name">{{ userName }}</span>
						<span class="nav-mobile-menu__user-login">{{ nav.delegation || nav.user.userName }}</span>
					</span>
					<v-icon v-if="!nav.delegation" size="18">arrow_forward_ios</v-icon>
				</button>
				<v-btn icon variant="text" @click="open = false">
					<v-icon>close</v-icon>
				</v-btn>
			</v-sheet>

			<div class="nav-mobile-menu__body">
				<v-btn v-if="onApp && !nav.delegation" color="primary" variant="flat" block prepend-icon="sync" class="mb-3" @click="run('synchronize')">{{ t('Synchronize') }}</v-btn>

				<v-list v-if="nav.updateReady || nav.extensionUpdate" density="compact" bg-color="transparent" class="nav-mobile-menu__list">
					<v-list-item v-if="nav.updateReady" prepend-icon="refresh" append-icon="arrow_forward_ios" :title="t('UpdateReadyToInstallText')" @click="run('installUpdate')" />
					<v-list-item v-if="nav.extensionUpdate" prepend-icon="extension" append-icon="arrow_forward_ios" :title="t('UpdateNeeded')" @click="run('extensionUpdate')" />
				</v-list>

				<NavMenuList v-if="menu.primary.length || menu.groups.length" :menu="menu" :active-view="activeView" class="nav-mobile-menu__list" @select="select" />

				<v-list density="compact" bg-color="transparent" class="nav-mobile-menu__list">
					<v-list-item v-if="onApp" prepend-icon="apps" append-icon="arrow_forward_ios" :title="t('Portal')" @click="run('portal')" />
					<v-list-item prepend-icon="help" append-icon="arrow_forward_ios" :title="t('Help')" @click="run('help')" />
					<template v-if="!nav.delegation">
						<v-list-item prepend-icon="release_alert" append-icon="arrow_forward_ios" :title="t('ShortReleaseNote')" @click="run('releaseNotes')" />
						<v-list-item prepend-icon="support_agent" append-icon="arrow_forward_ios" :title="t('ExternisSupport')" @click="run('support')" />
					</template>
				</v-list>

				<v-btn color="error" variant="flat" block prepend-icon="logout" class="mt-4" @click="run('logout')">{{ t('Logout') }}</v-btn>
			</div>
		</v-card>
	</v-dialog>
</template>

<script setup>
import NavMenuList from './NavMenuList.vue';
import { useAppChrome } from '@/composables/useAppChrome';
import { useTranslator } from '@/composables/useTranslator';

const emit = defineEmits(['select', 'action']);
const open = defineModel({ type: Boolean, default: false });

const t = useTranslator();
const { nav, onApp, menu, activeView, userName, color } = useAppChrome();

const run = (action) => {
	open.value = false;
	emit('action', action);
};

const select = (item) => {
	open.value = false;
	emit('select', item);
};
</script>
